
import styled from 'styled-components'
import { PrettyField } from '../forms/PrettyField'

export const LoginField = styled(PrettyField)`
	background-color: rgba(255,255,255,0.9);
`
